import type {ClientHoursRange, DeliveryMode, ExperienceRangeOption, FrequencyOption, Role} from './types';

export const ROLE_OPTIONS: readonly Role[] = ['Psycholoog', 'Coach', 'BMW'] as const;
//
// export const MAIN_QUALIFICATIONS = [
//   'Master Klinische Psychologie',
//   'Master A&O Psychologie',
//   'Master Klinische Neuropsycholoog',
//   'Master Sociale Psychologie',
//   'GZ-Psycholoog (BIG)',
//   'Psychotherapeut (BIG)',
//   'Klinisch Psycholoog (BIG)',
//   'VGCt Geregistreerd',
//   'EMDR Europe Practitioner',
//   'Schematherapeut',
//   'Overig...',
// ] as const;
//
// export const CATEGORIES = {
//   'CAT 1 (Ontwikkelvraagstuk)': [
//     'Ontwikkelvraag Perfectionisme, prestatiedruk en faalangst',
//     'Ontwikkelvraag Zelfbeeld- en onzekerheid',
//     'Omgaan met werkdruk en werkstress',
//     'Stress- en spanningsklachten (zonder ernstige uitval)',
//     'Klachten door onregelmatige werktijden / ploegendienst',
//     'Ondersteuning bij samenwerkingsproblemen en beginnend arbeidsconflict',
//     'Omgaan met baanverlies en aanpassingsproblemen',
//     'Verbeteren slaap- en leefstijl (energie & herstel)',
//     'Omgaan met eenzaamheid / sociaal isolement',
//     'Hulp bij uitdagingen in de privé situatie (mantelzorg, financiële zorgen, opvoeding, etc)',
//     'Loopbaan- en ontwikkelvraagstukken',
//   ],
//   'CAT 2 (Specifieke klachten)': [
//     'Neurodiversiteit in werk-en privé context',
//     'Omgaan met overgangsklachten en hormonale veranderingen',
//     'Angst- en paniekklachten (angststoornissen)',
//     'Burn-out en ernstige overspanningsklachten',
//     'Bore-out klachten (onderbelasting/mismatch werk)',
//     'Leven met chronische lichamelijke aandoening en pijn',
//     'Langdurige vermoeidheidsklachten / chronische vermoeidheid',
//     'Depressieve klachten en seizoensgebonden depressie',
//     'Problemen met emotieregulatie (woede- en agressieregulatie)',
//     'Levensfase- en identiteitsvragen (midlife, generatieverschillen, grote dilemma’s)',
//     'Psychische klachten bij psychosociale arbeidsbelasting (PSA)',
//     'Relatie- en scheidingsproblematiek (individuele begeleiding)',
//     'Hulp bij rouw- en verliesverwerking',
//     'Trauma en schokkende gebeurtenissen (enkelvoudig of beperkt meervoudig)',
//   ],
//   'CAT 3 (Specialistische begeleiding)': [
//     'Emotioneel-instabiele en impulsieve persoonlijkheidsstoornissen',
//     'Angstige persoonlijkheidsstoornissen',
//     'Complexe trauma-gerelateerde problematiek',
//     'Suïcidale gedachten en doodswens (zonder concreet plan)',
//     'Verslavingsproblematiek (alcohol, drugs, medicatie, gokken, nog functionerend)',
//   ],
//   'CAT 4 (Overbrugging)': [
//     'Genderidentiteits- en transitievraagstukken (transgenderzorg)',
//     'Ernstige depressieve stoornis / klinische depressie',
//     'Ernstige persoonlijkheidsproblematiek (psychose-achtige kenmerken)',
//     'Eetstoornissen (anorexia nervosa, etc.)',
//     'Conversiestoornis / functioneel-neurologische symptoomstoornis (FNS)',
//     'Niet-aangeboren hersenletsel (NAH)',
//     'Psychotische stoornissen (wanen, hallucinaties)',
//     'Licht verstandelijke beperking (LVB)',
//     'Slaapstoornissen die specialistische zorg vereisen',
//   ],
// } as const;
//
// export const PSYCH_METHODS = [
//   'ACT',
//   'CGT',
//   'Exposure',
//   'EMDR',
//   'Oplossingsgerichte gespreksvoering',
//   'Schematherapie',
//   'Systeemtherapie',
//   'Mindfulness gebaseerde therapie (o.a. MBCT)',
//   'Psychodynamische psychotherapie',
//   'Groepstherapie',
//   'Psycho educatie',
//   'Lichaamsgerichte therapie',
//   'Emotion Focused Therapy (EFT)',
//   'Dialectische gedragstherapie',
//   'Motiverende gespreksvoering',
//   'Anders...',
// ] as const;

export const EXP_RANGE_OPTIONS: readonly ExperienceRangeOption[] = [
    '< 1 jaar',
    '1-3 jaar',
    '3-5 jaar',
    '5-10 jaar',
    '10+ jaar',
] as const;

export const FREQUENCY_OPTIONS: readonly FrequencyOption[] = [
    'Dagelijks',
    'Wekelijks',
    'Maandelijks',
    'Zelden',
] as const;

export const DELIVERY_MODE_OPTIONS: readonly DeliveryMode[] = ['Online', 'Live', 'Beide'] as const;

export const CLIENT_HOURS_OPTIONS: readonly Exclude<ClientHoursRange, ''>[] = [
    '8-12',
    '12-16',
    '16-20',
    '20-24',
    '24+',
] as const;

export const AVAILABLE_DAYS_OPTIONS = [
    "Maandag",
    "Dinsdag",
    "Woensdag",
    "Donderdag",
    "Vrijdag",
] as const;

export const LANGUAGE_OPTIONS = [
    "Nederlands",
    "Engels",
    "Frans",
    "Duits",
    "Spaans",
    "Pools",
    "Turks",
    "Berbers",
    "Bulgaards",
    "Roemeens",
    "Arabisch",
    "Armeens",
    "Anders..."
] as const;
